function requestAPI(id, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}withdrawal/accept/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionAcceptWithdrawal(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'ACCEPT_WITHDRAWAL_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(id, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'ACCEPT_WITHDRAWAL_SUCCESS',
        success: result
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'ACCEPT_WITHDRAWAL_FAILURE',        
    error: error    
  })
}
